import { FETCHING_CONVERSATIONS_REQUEST, FETCHING_CONVERSATIONS_SUCCEDDED, FETCHING_CONVERSATIONS_FAILED, FETCHING_CONVERSATION_ACTIVITY_REQUEST, FETCHING_CONVERSATION_ACTIVITY_REQUEST_SUCCEEDED, FETCHING_CONVERSATION_ACTIVITY_REQUEST_FAILED, INVALIDATE_CONVERSATION_ACTIVITY, INVALIDATE_MEETING_DETAILS }
  from 'constants/actionTypes';

import _ from 'lodash';

const initialState = {
  loading: false,
  invalidated: true,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1
  },
  shares: {
    loading: false,
    items: [],
    totalShares: null
  }
};

function conversationsReducer(state = initialState, action) {

  switch (action.type) {

    case FETCHING_CONVERSATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        invalidated: true
      }

    case FETCHING_CONVERSATIONS_SUCCEDDED:
      var records = action.payload.response.records;
      var items = [];
      if (action.payload.currentPage == 0) {
        items = records;
      } else {
        items = [...state.items, ...records];
      }
      items = _.uniqBy(items, "id");

      return {
        ...state,
        loading: false,
        invalidated: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: action.payload.response.currentPage,
          totalPages: action.payload.response.totalPages
        }
      }

    case FETCHING_CONVERSATIONS_FAILED:
      return {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error
      }
    
    case FETCHING_CONVERSATION_ACTIVITY_REQUEST:
      return{
        ...state,
        shares: {
          loading: true
        }
      }
    
    case FETCHING_CONVERSATION_ACTIVITY_REQUEST_SUCCEEDED:
      return{
        ...state,
        shares: {
          loading: false,
          items: action.payload.response.records,
          totalShares: action.payload.response.totalRecordsCount
        }
      }

    case FETCHING_CONVERSATION_ACTIVITY_REQUEST_FAILED:
      return{
        ...state,
        shares: {
          loading: false,
          error: action.payload.error
        }
      }
    case INVALIDATE_CONVERSATION_ACTIVITY:
      return{
        ...state,
        shares: {
          loading: false,
          items: [],
          totalShares: null
        }
      }

    case INVALIDATE_MEETING_DETAILS: {
      return Object.assign({}, state, initialState);
    }

    default:
      return state;
  }

}

export { conversationsReducer };

